import { render } from "./TelegramUploadReceiptPage.vue?vue&type=template&id=eb0205ea&scoped=true"
import script from "./TelegramUploadReceiptPage.vue?vue&type=script&lang=js"
export * from "./TelegramUploadReceiptPage.vue?vue&type=script&lang=js"

import "./TelegramUploadReceiptPage.vue?vue&type=style&index=0&id=eb0205ea&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb0205ea"]])

export default __exports__